import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8636402"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row mb-9 mt-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold" }, "Search Rebate Schema ", -1))
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "row mb-9" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Schema Name ", -1))
const _hoisted_11 = { class: "col-9" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1))
const _hoisted_13 = { class: "mt-11" }
const _hoisted_14 = { class: "fv-row mb-7" }
const _hoisted_15 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "d-flex justify-content-between" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { style: {"width":"80px"} }
const _hoisted_22 = {
  key: 0,
  class: "text-center fs-4",
  style: {"color":"red"}
}
const _hoisted_23 = { class: "mt-13 d-flex flex-row-reverse" }

import { ref, onMounted } from "vue";
import { Field } from "vee-validate";
// import AccountService from "../../services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import RebateService from "../../../rebate/services/RebateService";
import { RebateDistributionTypes } from "@/core/types/RebateDistributionTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelRebateForm',
  props: {
    rebateType: {},
    accountDetails: {},
    fromRebateRuleDetailId: {},
    targetAccount: {},
    needConfirm: {}
  },
  emits: ["updateRebateRuleDetailId"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const { t } = useI18n();
const formData = ref({});
const formTab = ref("rate");
const isLoading = ref(true);
const schemaLoading = ref(true);
const showErrorMsg = ref(false);
const isViewDetail = ref(false);
const selectRebateSchema = ref<any>({});

const rebateSchemaInfo = ref<any>({
  loading: false,
  id: "",
});

const resetRebateForm = () => {
  setUpForm();
};

const createUpdateDirectRule = async (_op: string) => {
  formData.value["rebateRuleId"] = parseInt(rebateSchemaInfo.value.id);

  try {
    if (_op == "create") {
      await RebateService.putRebateAllocationRule(
        props.accountDetails.rebateClientRule.id,
        {
          distributionType: props.rebateType,
          rebateDirectSchemaId: formData.value.rebateRuleId,
        }
      );
      emits("updateRebateRuleDetailId", formData.value.rebateRuleId);
    } else if (_op == "update") {
      await RebateService.putRebateAllocationRule(
        props.accountDetails.rebateClientRule.id,
        {
          distributionType: props.rebateType,
          rebateDirectSchemaId: formData.value.rebateRuleId,
        }
      );
      emits("updateRebateRuleDetailId", formData.value.rebateRuleId);
    }

    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      resetRebateForm();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const remoteMethod = async (query: string) => {
  if (query) {
    rebateSchemaInfo.value.loading = true;

    const options = await RebateService.getRebateSchemaList({
      keyword: query,
    });

    rebateSchemaInfo.value["options"] = options.data;
    rebateSchemaInfo.value.loading = false;
  } else {
    rebateSchemaInfo.value["options"] = [];
  }
};

const setUpForm = async () => {
  schemaLoading.value = true;

  if (rebateSchemaInfo.value.id.length == 0) {
    rebateSchemaInfo.value.id = "";
    return;
  }

  try {
    const resSymbolList = await RebateService.getSymbolsList();

    selectRebateSchema.value = resSymbolList.reduce((acc, item) => {
      const category = item.category;

      if (!acc[category]) {
        acc[category] = {};
      }

      acc[category][item.code] = {
        symbolCode: item.code,
        rate: 0,
        pips: 0,
        commission: 0,
      };

      return acc;
    }, {});

    const categoryMap = {};
    for (const item of resSymbolList) {
      categoryMap[item.code] = item.category;
    }

    const resSchema = await RebateService.getRebateSchema(
      parseInt(rebateSchemaInfo.value.id)
    );

    rebateSchemaInfo.value.name = resSchema.name;
    rebateSchemaInfo.value.note = resSchema.note;

    resSchema.rebateDirectSchemaItems.forEach(function (item) {
      if (!categoryMap[item.symbolCode]) return;
      selectRebateSchema.value[categoryMap[item.symbolCode]][item.symbolCode] =
        {
          symbolCode: item.symbolCode,
          rate: item.rate,
          pips: item.pips,
          commission: item.commission,
        };
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
  schemaLoading.value = false;
};

onMounted(async () => {
  if (
    props.fromRebateRuleDetailId != -1 &&
    props.fromRebateRuleDetailId != null
  ) {
    isViewDetail.value = true;
    rebateSchemaInfo.value.id = props.fromRebateRuleDetailId;
    setUpForm();
  }
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingRing)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_select, {
                modelValue: rebateSchemaInfo.value.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rebateSchemaInfo.value.id) = $event)),
                clearable: "",
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                placeholder: "Please enter a keyword",
                "remote-method": remoteMethod,
                loading: rebateSchemaInfo.value.loading,
                onChange: setUpForm
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateSchemaInfo.value.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.key,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "loading"])
            ]),
            (isViewDetail.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-light btn-success btn-sm ms-5",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (createUpdateDirectRule('update')))
                }, " Update Rebate Schema "))
              : _createCommentVNode("", true)
          ])
        ]),
        (rebateSchemaInfo.value.id != '' && schemaLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_LoadingRing)
            ]))
          : _createCommentVNode("", true),
        (rebateSchemaInfo.value.id != '' && !schemaLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_unref(Field), {
                    modelValue: rebateSchemaInfo.value.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rebateSchemaInfo.value.name) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: rebateSchemaInfo.value.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rebateSchemaInfo.value.name) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_unref(Field), {
                    modelValue: rebateSchemaInfo.value.note,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rebateSchemaInfo.value.note) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: rebateSchemaInfo.value.note,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rebateSchemaInfo.value.note) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", _hoisted_16, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'rate' }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (formTab.value = 'rate'))
                      }, "Rate", 2)
                    ]),
                    _createElementVNode("li", _hoisted_17, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'pips' }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (formTab.value = 'pips'))
                      }, "Pips", 2)
                    ]),
                    _createElementVNode("li", _hoisted_18, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'commission' }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (formTab.value = 'commission'))
                      }, "Commission", 2)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectRebateSchema.value, (symbols, category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category,
                    style: {"box-shadow":"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"},
                    class: "mb-7 p-7"
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h3", null, _toDisplayString(category), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(symbols, (rule, symbol) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-4 mt-5",
                          key: symbol
                        }, [
                          _createVNode(_unref(Field), {
                            modelValue: selectRebateSchema.value[category][symbol][formTab.value],
                            "onUpdate:modelValue": ($event: any) => ((selectRebateSchema.value[category][symbol][formTab.value]) = $event),
                            class: "form-control form-control-lg form-control-solid",
                            type: "number",
                            name: "symbolRule",
                            autocomplete: "off"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: selectRebateSchema.value[category][symbol][formTab.value],
                                "onUpdate:modelValue": ($event: any) => ((selectRebateSchema.value[category][symbol][formTab.value]) = $event),
                                size: "large"
                              }, {
                                prepend: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("label", null, _toDisplayString(symbol), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                (showErrorMsg.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Please input target account number. "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btn btn-light btn-danger btn-lg me-3 mb-9",
                    onClick: resetRebateForm
                  }, " Reset "),
                  (!isViewDetail.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-light btn-success btn-lg me-3 mb-9",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (createUpdateDirectRule('create')))
                      }, " Apply to Client "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})